(function () {
  var script = document.querySelector('script[data-bans-shipping-script]');
  var strings = Object.assign({
    regionLabel: 'Select region / country',
    countryLabel: 'Select country',
    allRegions: 'Show all regions',
    noEntries: 'No entries for this selection.',
    oneEntry: 'entry shown.',
    manyEntries: 'entries shown.'
  }, script ? script.dataset : {});

  function initBansShippingPage() {
    var page = document.querySelector('.bans-shipping-page');
    if (!page || page.dataset.shippingInit === 'true') return;
    page.dataset.shippingInit = 'true';

    var activePanelState = new WeakMap();
    var TABLE_BY_FILTER_ID = {
      'bans-eu-filter': 'bans-eu-table',
      'bans-noneu-filter': 'bans-noneu-table',
      'bans-world-filter': 'bans-world-table'
    };
    var FILTER_ID_BY_TABLE_ID = {
      'bans-eu-table': 'bans-eu-filter',
      'bans-noneu-table': 'bans-noneu-filter',
      'bans-world-table': 'bans-world-filter'
    };
    var FILTER_LABEL_BY_TABLE_ID = {
      'bans-world-table': strings.regionLabel
    };
    var FILTER_DEFAULT_BY_TABLE_ID = {
      'bans-world-table': strings.allRegions
    };
    var SVG_NS = 'http://www.w3.org/2000/svg';

    function normalizeText(text) {
      return (text || '').replace(/\s+/g, ' ').trim();
    }

    function svgElement(name, attributes) {
      var element = document.createElementNS(SVG_NS, name);

      Object.keys(attributes || {}).forEach(function (attribute) {
        element.setAttribute(attribute, attributes[attribute]);
      });

      return element;
    }

    function createClockIcon() {
      var svg = svgElement('svg', {
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'aria-hidden': 'true'
      });

      svg.appendChild(svgElement('circle', { cx: '12', cy: '12', r: '9' }));
      svg.appendChild(svgElement('path', { d: 'M12 7v5l3 2' }));

      return svg;
    }

    function createCheckIcon() {
      var svg = svgElement('svg', {
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2.4',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'aria-hidden': 'true'
      });

      svg.appendChild(svgElement('path', { d: 'M5 12.5l4.5 4.5L19 7' }));

      return svg;
    }

    function createGlobeIcon() {
      var svg = svgElement('svg', {
        class: 'bans-globe',
        viewBox: '0 0 21 21',
        fill: 'none',
        stroke: '#111',
        'stroke-width': '1.3',
        'aria-hidden': 'true'
      });

      svg.appendChild(svgElement('circle', { cx: '10.5', cy: '10.5', r: '8.5' }));
      svg.appendChild(svgElement('ellipse', { cx: '10.5', cy: '10.5', rx: '4', ry: '8.5' }));
      svg.appendChild(svgElement('line', { x1: '2', y1: '10.5', x2: '19', y2: '10.5' }));
      svg.appendChild(svgElement('line', { x1: '10.5', y1: '2', x2: '10.5', y2: '19' }));

      return svg;
    }

    function createFlagIcon(type) {
      var svg = svgElement('svg', {
        class: 'bans-flag',
        viewBox: '0 0 22 16',
        'aria-hidden': 'true'
      });
      var group;

      if (type === 'de') {
        svg.appendChild(svgElement('rect', { width: '22', height: '16', fill: '#000' }));
        svg.appendChild(svgElement('rect', { y: '5.33', width: '22', height: '5.33', fill: '#D00' }));
        svg.appendChild(svgElement('rect', { y: '10.66', width: '22', height: '5.34', fill: '#FFCE00' }));
      } else if (type === 'at') {
        svg.appendChild(svgElement('rect', { width: '22', height: '16', fill: '#ED2939' }));
        svg.appendChild(svgElement('rect', { y: '5.33', width: '22', height: '5.34', fill: '#fff' }));
      } else if (type === 'eu') {
        svg.appendChild(svgElement('rect', { width: '22', height: '16', fill: '#039' }));
        group = svgElement('g', { fill: '#FC0' });
        [
          ['11', '3.5'], ['13.1', '4.06'], ['14.64', '5.6'], ['15.2', '7.7'],
          ['14.64', '9.8'], ['13.1', '11.34'], ['11', '11.9'], ['8.9', '11.34'],
          ['7.36', '9.8'], ['6.8', '7.7'], ['7.36', '5.6'], ['8.9', '4.06']
        ].forEach(function (point) {
          group.appendChild(svgElement('circle', { cx: point[0], cy: point[1], r: '0.8' }));
        });
        svg.appendChild(group);
      } else if (type === 'ch') {
        svg.appendChild(svgElement('rect', { width: '22', height: '16', fill: '#D52B1E' }));
        svg.appendChild(svgElement('rect', { x: '9.5', y: '3.5', width: '3', height: '9', fill: '#fff' }));
        svg.appendChild(svgElement('rect', { x: '6.5', y: '6.5', width: '9', height: '3', fill: '#fff' }));
      } else if (type === 'uk') {
        svg.appendChild(svgElement('rect', { width: '22', height: '16', fill: '#012169' }));
        svg.appendChild(svgElement('path', { d: 'M0 0L22 16M22 0L0 16', stroke: '#fff', 'stroke-width': '3.2' }));
        svg.appendChild(svgElement('path', { d: 'M0 0L22 16M22 0L0 16', stroke: '#C8102E', 'stroke-width': '1.6' }));
        svg.appendChild(svgElement('path', { d: 'M11 0V16M0 8H22', stroke: '#fff', 'stroke-width': '5' }));
        svg.appendChild(svgElement('path', { d: 'M11 0V16M0 8H22', stroke: '#C8102E', 'stroke-width': '3' }));
      }

      return svg;
    }

    function overviewIconForLabel(label) {
      if (label === 'Deutschland') return createFlagIcon('de');
      if (label === 'Österreich') return createFlagIcon('at');
      if (label === 'EU') return createFlagIcon('eu');
      if (label === 'Schweiz') return createFlagIcon('ch');
      if (label === 'Vereinigtes Königreich') return createFlagIcon('uk');
      if (label === 'Weltweit') return createGlobeIcon();
      return null;
    }

    function prependIcon(element, icon) {
      if (!element || !icon || element.querySelector('svg')) return;
      element.insertBefore(icon, element.firstChild);
    }

    function ensureShippingIcons(page) {
      prependIcon(page.querySelector('.bans-shipping-page__cutoff'), createClockIcon());

      page.querySelectorAll('.bans-shipping-page__table-wrap--overview tbody tr').forEach(function (row) {
        var place = row.querySelector('.bans-shipping-page__place');
        prependIcon(place, overviewIconForLabel(rowPlaceText(row)));
      });

      page.querySelectorAll('.bans-shipping-page__check').forEach(function (check) {
        prependIcon(check, createCheckIcon());
      });
    }

    // On phones the stylesheet shows each table row as a small block instead of four narrow columns: every value cell
    // gets the text of its column title as a label. Explicit table roles keep the tables readable for screen readers
    // when the cells are stacked. Without this script the tables stay as they are.
    function labelTableCells(page) {
      page.querySelectorAll('.bans-shipping-page__table').forEach(function (table) {
        var heads = Array.prototype.map.call(table.querySelectorAll('thead th'), function (th) {
          return th.textContent.replace(/\s+/g, ' ').trim();
        });
        if (heads.length < 2) return;

        table.setAttribute('role', 'table');
        Array.prototype.forEach.call(table.querySelectorAll('thead, tbody'), function (group) {
          group.setAttribute('role', 'rowgroup');
        });

        Array.prototype.forEach.call(table.querySelectorAll('tr'), function (row) {
          row.setAttribute('role', 'row');

          Array.prototype.forEach.call(row.children, function (cell, index) {
            if (cell.tagName === 'TH') {
              cell.setAttribute('role', 'columnheader');
              return;
            }

            cell.setAttribute('role', 'cell');
            if (index > 0 && heads[index]) cell.setAttribute('data-label', heads[index]);
          });
        });

        table.classList.add('has-cell-labels');
      });
    }

    function removeStrippedPolicyStyleText(page) {
      var rte = page.closest('.rte');
      if (!rte || !rte.closest('.shopify-policy__body')) return;

      while (rte.firstChild && rte.firstChild !== page) {
        rte.removeChild(rte.firstChild);
      }
    }

    function takePreviousText(element, fallback) {
      var node = element.previousSibling;

      while (node) {
        var previous = node.previousSibling;

        if (node.nodeType === Node.TEXT_NODE) {
          var text = normalizeText(node.textContent);
          node.parentNode.removeChild(node);
          if (text) return text;
        } else if (node.nodeType === Node.ELEMENT_NODE && normalizeText(node.textContent) === '') {
          node.parentNode.removeChild(node);
        } else {
          break;
        }

        node = previous;
      }

      return fallback;
    }

    function repairStrippedDisclosures(page) {
      page.querySelectorAll('.bans-shipping-page__disclosure-body').forEach(function (body) {
        if (body.closest('details.bans-shipping-page__disclosure') || body.closest('.bans-shipping-page__disclosure[data-accordion]')) return;

        var details = document.createElement('details');
        details.className = 'bans-shipping-page__disclosure';

        var summary = document.createElement('summary');
        summary.textContent = takePreviousText(body, 'Alle Länder & Preise anzeigen');

        body.parentNode.insertBefore(details, body);
        details.appendChild(summary);
        details.appendChild(body);
      });
    }

    function rowFilterKeys(row) {
      return String(row.className || '').split(/\s+/).reduce(function (keys, className) {
        if (className.indexOf('bans-shipping-row--') === 0) {
          keys.push(className.replace('bans-shipping-row--', ''));
        }

        return keys;
      }, []);
    }

    function rowPlaceText(row) {
      var place = row.querySelector('.bans-shipping-page__place');
      return normalizeText(place ? place.textContent : row.cells[0] && row.cells[0].textContent);
    }

    function rowFilterLabels(row, keys) {
      var label = rowPlaceText(row);
      var parts = label.split(',').map(function (part) {
        return normalizeText(part);
      }).filter(Boolean);

      if (keys.length > 1 && parts.length === keys.length) return parts;
      return keys.map(function () {
        return label;
      });
    }

    function appendFilterOption(select, value, label) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = label;
      select.appendChild(option);
    }

    function repairStrippedFilters(page) {
      page.querySelectorAll('.bans-shipping-page__filter').forEach(function (filter) {
        if (filter.querySelector('select')) return;

        var body = filter.closest('.bans-shipping-page__disclosure-body');
        var table = body ? body.querySelector('.bans-shipping-page__table') : null;
        if (!table || !table.id) return;

        var filterId = FILTER_ID_BY_TABLE_ID[table.id] || table.id + '-filter';
        var labelText = FILTER_LABEL_BY_TABLE_ID[table.id] || strings.countryLabel;
        var defaultText = FILTER_DEFAULT_BY_TABLE_ID[table.id] || 'Alle Länder anzeigen';
        var status = filter.querySelector('.bans-shipping-page__filter-status') || document.createElement('div');

        status.className = 'bans-shipping-page__sr-only bans-shipping-page__filter-status';
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');

        filter.textContent = '';

        var label = document.createElement('label');
        label.setAttribute('for', filterId);
        label.textContent = labelText;

        var select = document.createElement('select');
        select.id = filterId;
        select.className = 'bans-shipping-page__filter-select';
        select.setAttribute('aria-controls', table.id);

        appendFilterOption(select, '', defaultText);

        var added = {};
        findFilterRows(table).forEach(function (row) {
          var keys = rowFilterKeys(row);
          var labels = rowFilterLabels(row, keys);

          keys.forEach(function (key, index) {
            if (added[key]) return;
            added[key] = true;
            appendFilterOption(select, key, labels[index] || labels[0] || key);
          });
        });

        filter.appendChild(label);
        filter.appendChild(select);
        filter.appendChild(status);
      });
    }

    function repairStrippedFaqItems(page) {
      page.querySelectorAll('div.bans-shipping-page__prose').forEach(function (answer) {
        if (answer.closest('details.bans-shipping-page__faq-item') || answer.closest('.bans-shipping-page__faq-item[data-accordion]')) return;

        var question = takePreviousText(answer, '');
        if (!question) return;

        var details = document.createElement('details');
        details.className = 'bans-shipping-page__faq-item';

        var summary = document.createElement('summary');
        summary.textContent = question;

        answer.parentNode.insertBefore(details, answer);
        details.appendChild(summary);
        details.appendChild(answer);
      });
    }

    function repairPolicyMarkup(page) {
      removeStrippedPolicyStyleText(page);
      repairStrippedDisclosures(page);
      repairStrippedFilters(page);
      repairStrippedFaqItems(page);
      ensureShippingIcons(page);
      labelTableCells(page);
    }

    function panelAnimationDuration(panel) {
      var inner = panel.querySelector('.bans-shipping-page__accordion-inner');
      var height = inner ? inner.scrollHeight : panel.scrollHeight;
      return Math.max(600, Math.min(1200, Math.round(height * 0.65)));
    }

    function wrapPanelContent(panel) {
      if (panel.firstElementChild && panel.firstElementChild.classList.contains('bans-shipping-page__accordion-inner')) {
        return panel.firstElementChild;
      }

      var inner = document.createElement('div');
      inner.className = 'bans-shipping-page__accordion-inner';

      while (panel.firstChild) {
        inner.appendChild(panel.firstChild);
      }

      panel.appendChild(inner);
      return inner;
    }

    function transformDetails(details, index) {
      var summary = details.querySelector('summary');
      var panel = details.querySelector('.bans-shipping-page__disclosure-body') || details.querySelector('.bans-shipping-page__prose');
      if (!summary || !panel) return null;

      var accordion = document.createElement('div');
      accordion.className = details.className;
      accordion.setAttribute('data-accordion', '');

      Array.prototype.forEach.call(details.attributes, function (attribute) {
        if (attribute.name === 'class' || attribute.name === 'open') return;
        accordion.setAttribute(attribute.name, attribute.value);
      });

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'bans-shipping-page__accordion-trigger';
      trigger.innerHTML = summary.innerHTML;

      if (!panel.id) {
        panel.id = 'bans-shipping-accordion-panel-' + index;
      }

      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      wrapPanelContent(panel);

      accordion.appendChild(trigger);
      accordion.appendChild(panel);
      details.parentNode.replaceChild(accordion, details);

      panel.hidden = !details.open;
      panel.style.height = details.open ? 'auto' : '0px';

      if (details.open) {
        accordion.setAttribute('data-open', 'true');
      }

      return {
        accordion: accordion,
        trigger: trigger,
        panel: panel
      };
    }

    function cancelPanelAnimation(panel) {
      var state = activePanelState.get(panel);
      if (!state) return;
      state.cleanup();
      activePanelState.delete(panel);
    }

    function clearPanelAnimationState(accordion, panel) {
      accordion.removeAttribute('data-animating');
      accordion.removeAttribute('data-closing');
      panel.style.removeProperty('--bans-accordion-duration');
      panel.style.removeProperty('transition');
      if (panel.hidden) {
        panel.style.height = '0px';
        panel.style.margin = '0';
      }
    }

    function animateAccordion(accordion, trigger, panel, open) {
      cancelPanelAnimation(panel);

      var inner = wrapPanelContent(panel);
      var duration = panelAnimationDuration(panel);
      var startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      var finished = false;
      var timer;

      function cleanup() {
        panel.removeEventListener('transitionend', onTransitionEnd);
        window.clearTimeout(timer);
      }

      function done() {
        if (finished) return;
        finished = true;
        cleanup();

        if (open) {
          panel.style.height = 'auto';
          panel.style.margin = '';
          accordion.setAttribute('data-open', 'true');
        } else {
          panel.style.height = '0px';
          panel.style.margin = '0';
          panel.hidden = true;
          accordion.removeAttribute('data-open');
        }

        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        clearPanelAnimationState(accordion, panel);
        activePanelState.delete(panel);
      }

      function onTransitionEnd(ev) {
        if (ev.target !== panel || ev.propertyName !== 'height') return;
        done();
      }

      panel.style.setProperty('--bans-accordion-duration', duration + 'ms');
      panel.style.transition = 'height ' + duration + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
      accordion.setAttribute('data-animating', 'true');
      accordion.toggleAttribute('data-closing', !open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.addEventListener('transitionend', onTransitionEnd);

      if (open) {
        panel.hidden = false;
        accordion.setAttribute('data-open', 'true');
        panel.style.height = '0px';
        panel.offsetHeight;
        requestAnimationFrame(function () {
          panel.style.height = inner.scrollHeight + 'px';
        });
      } else {
        accordion.removeAttribute('data-open');
        panel.style.height = startHeight + 'px';
        panel.offsetHeight;
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
      }

      timer = window.setTimeout(done, duration + 120);
      activePanelState.set(panel, {
        cleanup: cleanup
      });
    }

    function findFilterTable(select) {
      var tableId = select.getAttribute('aria-controls') || TABLE_BY_FILTER_ID[select.id];
      if (tableId) {
        var tableById = document.getElementById(tableId);
        if (tableById) return tableById;
      }

      var body = select.closest('.bans-shipping-page__disclosure-body');
      return body ? body.querySelector('.bans-shipping-page__table') : null;
    }

    function findFilterRows(table) {
      var rows = table.querySelectorAll('tbody tr.bans-shipping-row');
      if (rows.length) return rows;
      return table.querySelectorAll('tbody tr[data-keys]');
    }

    function rowMatchesFilter(row, value) {
      if (!value) return true;
      if (row.classList.contains('bans-shipping-row--' + value)) return true;
      var keys = (row.getAttribute('data-keys') || '').trim().split(/\s+/).filter(Boolean);
      return keys.indexOf(value) !== -1;
    }

    repairPolicyMarkup(page);

    page.classList.add('bans-shipping-page--accordion-ready');
    page.setAttribute('data-accordion-ready', 'true');

    page.querySelectorAll('details.bans-shipping-page__disclosure, details.bans-shipping-page__faq-item').forEach(function (details, index) {
      var item = transformDetails(details, index);
      if (!item) return;

      item.trigger.addEventListener('click', function () {
        animateAccordion(item.accordion, item.trigger, item.panel, !item.accordion.hasAttribute('data-open'));
      });
    });

    page.querySelectorAll('.bans-shipping-page__filter-select').forEach(function (select) {
      var region = select.closest('.bans-shipping-page__region') || select.closest('.bans-shipping-page__section');
      var table = findFilterTable(select);
      if (!table) return;

      var rows = findFilterRows(table);
      var body = select.closest('.bans-shipping-page__disclosure-body');
      var status = region ? region.querySelector('.bans-shipping-page__filter-status') : body ? body.querySelector('.bans-shipping-page__filter-status') : null;

      function applyFilter() {
        var value = select.value;
        var visible = 0;

        rows.forEach(function (row) {
          var show = rowMatchesFilter(row, value);
          row.hidden = !show;
          row.classList.toggle('is-filtered-out', !show);
          if (show) visible++;
        });

        if (!status) return;
        if (value === '') {
          status.textContent = '';
        } else if (visible === 0) {
          status.textContent = strings.noEntries;
        } else {
          status.textContent = visible + ' ' + (visible === 1 ? strings.oneEntry : strings.manyEntries);
        }
      }

      select.addEventListener('change', applyFilter);
      select.addEventListener('input', applyFilter);
    });
  }

  function bootBansShippingPage() {
    initBansShippingPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBansShippingPage);
  } else {
    bootBansShippingPage();
  }

  window.addEventListener('load', bootBansShippingPage);
})();
